import Button from '@/shared/Buttons/Button'
import EditIcon from '@/assets/icons/edit.svg?react'

interface IProps {
  onClick: () => void
}

const FormEditButton = (props: IProps) => {
  return (
    <Button
      size="default"
      type="default"
      icon={<EditIcon />}
      text="Редактировать"
      onClick={props.onClick}
      buttonType="button"
    />
  )
}

export default FormEditButton
